import { PropsWithChildren } from 'react';
import { ToolNavigationExpandedProvider } from './components/ToolNavigationExpandedProvider';
import {
	ToolNavigationDataProvider,
} from '../../../../ReactSharedScripts/modules/toolNavigation/components/ToolNavigationDataProvider';
import {
	ToolNavigationActiveModuleProvider,
} from '../../../../ReactSharedScripts/modules/toolNavigation/components/ToolNavigationActiveModuleProvider';
import {
	ToolNavigationRoleSwitcherProvider,
} from '../../../../ReactSharedScripts/modules/toolNavigation/components/ToolNavigationRoleSwitcherProvider';

function ToolNavigationProviders({ children }: PropsWithChildren) {
	return (
		<ToolNavigationDataProvider>
			<ToolNavigationExpandedProvider>
				<ToolNavigationActiveModuleProvider>
					<ToolNavigationRoleSwitcherProvider>{children}</ToolNavigationRoleSwitcherProvider>
				</ToolNavigationActiveModuleProvider>
			</ToolNavigationExpandedProvider>
		</ToolNavigationDataProvider>
	);
}

export { ToolNavigationProviders };
